import React from 'react';

const EIMZO = () => {
  return (
    <div>
      EIMZO
    </div>
  );
};

export default EIMZO;
